import Alert from 'components/ui/base/alert/Alert';
import Button from 'components/ui/base/button';
import { FC } from 'react';
import { useNavigate } from 'react-router-dom';
import DeclarationTabKeys from 'views/declarations/utils/DeclarationTabKeys';

const AlertRefundDepositRequested: FC = () => {
    const navigate = useNavigate();

    return (
        <Alert
            message={
                <>
                    Deposit refund requested by Revenue
                    <Button
                        size="small"
                        type="link"
                        onClick={() => {
                            navigate('refunds/deposits/new', {
                                state: { activeTabKey: DeclarationTabKeys.REFUNDS },
                            });
                        }}
                    >
                        Fill out form
                    </Button>
                </>
            }
            type="info"
            showIcon
        />
    );
};

export default AlertRefundDepositRequested;
